export const Keys = {
    Enter: 'Enter'
}